// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShareButtons-module--wrapper--CjmUH"};